<template>
  <b-field :label="localCourse ? 'Curso' : ''" label-position="on-border">
    <b-autocomplete
      v-model="localCourse"
      expanded
      :data="filteredCoursesArray"
      :open-on-focus="true"
      :keep-first="true"
      placeholder="Exemplo: Administração"
      @select="option => (selected = option)"
      @input="$emit('update-course', localCourse, name)"
    >
      <template slot="empty">Sem resultados</template>
    </b-autocomplete>
  </b-field>
</template>

<script>
import { cursos } from "../../assets/js/cursos";

export default {
  props: ["course", "name"],

  data() {
    return {
      coursesList: [],
      localCourse: ""
    };
  },

  computed: {
    filteredCoursesArray() {
      let filteredCoursesArray = [];
      filteredCoursesArray = this.coursesList.filter(option => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.localCourse.toLowerCase()) >= 0
        );
      });
      return filteredCoursesArray;
    }
  },

  mounted() {
    if (this.course) this.localCourse = this.course;
    this.coursesList = cursos;
  }
};
</script>
